<template>
  <div class="text-dark">
    <ChooseSalarySystem
      v-if="isAllLoaded && !salarySystem"
      :schoolId="schoolId"
    ></ChooseSalarySystem>
    <div class="d-sub-header">
      <p class="d-sub-header__link"
         :class="{'d-sub-header__link--active': activePage === 'tillæg'}"
         @click="setActivePage('tillæg')">Tillæg
      </p>
      <p class="d-sub-header__link"
         :class="{'d-sub-header__link--active': activePage === 'tillægstyper'}"
         @click="setActivePage('tillægstyper')">Tillægstyper
      </p>
    </div>
    <template v-if="isAllLoaded">
      <SupplementsList
        v-if="activePage === 'tillæg'"
        :schoolId="schoolId"
        :schoolYear="schoolYear"
        :schoolYearId="schoolYearId"
        :supplementTypes="activeSupplementTypes"
      ></SupplementsList>
      <SupplementsTypes
        v-if="activePage === 'tillægstyper'"
        :schoolId="schoolId"
        :isLoading="isLoadingSupplementTypes"
        :supplementTypes="activeSupplementTypes"
        @readSupplementTypes="readSupplementTypes"
      ></SupplementsTypes>
    </template>
  </div>
</template>

<script>
import docendo from '../../docendo'
import SupplementsTypes from './SupplementsTypes.vue'
import SupplementsList from './SupplementsList.vue'
import Loader from '../common/Loader.vue'
import moment from 'moment'
import ChooseSalarySystem from './ChooseSalarySystem.vue'

export default {
  components: {ChooseSalarySystem, SupplementsList, SupplementsTypes, Loader},
  data () {
    return {
      activePage: 'tillæg',
      isLoadingSupplementTypes: true,
      supplementTypes: []
    }
  },
  computed: {
    activeSchool () {
      return this.$store.state.activeSchool
    },
    salarySystem () {
      return this.activeSchool && this.activeSchool.salary_system ? this.activeSchool.salary_system : null
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    schoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    schoolYearId () {
      return this.$store.getters.schoolYearId
    },
    isAllLoaded () {
      return this.schoolId && this.schoolYearId && this.schoolYear
    },
    activeSupplementTypes () {
      const today = moment()

      return this.supplementTypes.filter(supplement => {
        const period = supplement.valid_period.split('...')
        const startDate = moment(period[0], 'YYYY-MM-DD')
        const endDate = moment(period[1], 'YYYY-MM-DD')

        return today.isSameOrAfter(startDate) && today.isSameOrBefore(endDate)
      })
    },
    expiredSupplementTypes () {
      const today = moment()

      return this.supplementTypes.filter(supplement => {
        const period = supplement.valid_period.split('...')
        const endDate = moment(period[1], 'YYYY-MM-DD')

        return today.isAfter(endDate)
      })
    }
  },
  watch: {
    schoolId: {
      handler (val) {
        this.readSupplementTypes()
      },
      immediate: true
    }
  },
  methods: {
    setActivePage (page) {
      this.activePage = page
    },
    readSupplementTypes () {
      this.isLoadingSupplementTypes = true
      docendo.listSalarySupplementTypes(this.schoolId, success => {
        this.supplementTypes = success
        this.isLoadingSupplementTypes = false
      })
    }
  }
}
</script>

<style scoped>
.do-margin-grid {
  margin: -1rem;
}

.d-sub-header {
  height: 40px;
  border-bottom: solid 1px #CCCCCC;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 10px;
}

.d-sub-header__link {
  font-weight: bold;
  margin: 0 20px;
  display: flex;
  align-items: center;
  font-size: 11px;
  color: #3e4450;
  opacity: 0.7;
  text-transform: uppercase;
  border-bottom: 2px solid transparent;
  border-top: 2px solid transparent;
  cursor: pointer;
}

.d-sub-header__link--active {
  opacity: 1;
  border-bottom: 2px solid #468AD7;
  transition: all 0.15s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// Supplements.vue?418f11fc